import Input from '@jetbrains/ring-ui/components/input/input'

import useSearchInput from '../../../../../hooks/useSearchInput'
import type {FilterOptions} from '../../../../../types'

type Props = {
  className?: string
  fromBuildNumber: string
  toBuildNumber: string
  onChangeFilter: (filter: FilterOptions) => unknown
}

function BuildsFilter({className, fromBuildNumber, toBuildNumber, onChangeFilter}: Props) {
  const fromBuildNumberInput = useSearchInput(fromBuildNumber, data =>
    onChangeFilter({fromBuildNumber: data}),
  )
  const toBuildNumberInput = useSearchInput(toBuildNumber, data =>
    onChangeFilter({toBuildNumber: data}),
  )

  return (
    <>
      <Input
        inputRef={fromBuildNumberInput.inputRef}
        type="search"
        placeholder="From build..."
        className={className}
        autoComplete={fromBuildNumber !== fromBuildNumberInput.value ? 'off' : 'on'}
        value={fromBuildNumberInput.value}
        onChange={fromBuildNumberInput.onChange}
        onClear={fromBuildNumberInput.onClear}
      />
      <Input
        inputRef={toBuildNumberInput.inputRef}
        type="search"
        placeholder="To build..."
        className={className}
        autoComplete={toBuildNumber !== toBuildNumberInput.value ? 'off' : 'on'}
        value={toBuildNumberInput.value}
        onChange={toBuildNumberInput.onChange}
        onClear={toBuildNumberInput.onClear}
      />
    </>
  )
}

export default BuildsFilter
